const config = {
  baseUrl: process.env.REACT_APP_BASE_URL188 || "https://188.bodecom.com",
  excelProyectosPorOrganizaciones:
    process.env.REACT_APP_EXCEL_PROYECTOS_POR_ORGANIZACIONES188 ||
    "https://188.bodecom.com",
  baseDirUrl:
    process.env.REACT_APP_BASE_DIR_URL188 ||
    "/var/www/188/backend/DocumentosFAO/DocumentosReportes",
};
export default config;

/*
const config = {
  baseUrl: "http://localhost:5007",
  excelProyectosPorOrganizaciones:
    process.env.REACT_APP_EXCEL_PROYECTOS_POR_ORGANIZACIONES188 ||
    "defaultExcelUrl",
  baseDirUrl:
    process.env.REACT_APP_BASE_DIR_URL188 ||
    "/Volumes/bodecom/bodecom_166/backend/DocumentosFAO/DocumentosReportes",
};
export default config;
*/

